import React from 'react';
import PlanUsageSwitch from './PlanUsageSwitch';
import PlanSliders from './PlanSliders';

const PlanDetails = ({ plan, sliders }) =>
  <div className="plan-details">
    {plan === 'developer-pro' && <PlanUsageSwitch />}
    <PlanSliders sliders={sliders} />
  </div>;

export default PlanDetails;



// WEBPACK FOOTER //
// ./src/components/pricingPlans/components/planBox/PlanDetails.js